import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
    @Input() text = "Ceci n'est pas un tooltip.";

    constructor() { }

    ngOnInit() {
    }

}
